import { apiSlice } from "../../app/api/apiSlice";

export const skillnewApiSlice = apiSlice.injectEndpoints({
  tagTypes: ["Skill"],
  endpoints: (builder) => ({
    skills: builder.query({
      query: () => ({
        url: "/master/skill",
        method: "GET",
      }),
      providesTags: ["Skill"],
      // keepUnusedDataFor: 5,
    }),
    addSkills: builder.mutation({
      query: (data) => ({
        url: "/master/skill",
        method: "POST",
        body: { ...data },
      }),
      invalidatesTags: ["Skill"],
    }),
    updateSkills: builder.mutation({
      query: (data) => ({
        url: "/master/skill",
        method: "PUT",
        body: { ...data },
      }),
      invalidatesTags: ["Skill"],
    }),
    deleteSkills: builder.mutation({
      query: (id) => ({
        url: `/master/skill/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Skill"],
    }),
  }),
});

export const {
  useSkillsQuery,
  useAddSkillsMutation,
  useUpdateSkillsMutation,
  useDeleteSkillsMutation,
} = skillnewApiSlice;
